export default __webpack_public_path__ + "static/media/Flower-Cake-2.39a5efaf.jpg";